import { gql } from "@apollo/client"

export const UPDATE_BOOKING = gql`
  mutation updateBooking($id: ID!, $input: UpdateBookingInput!) {
    updateBooking(id: $id, input: $input) {
      id
      startTime
      endTime
      customerPhone
      notes
      status
      updatedAt
    }
  }
`;

export const CANCEL_BOOKING = gql`
  mutation cancelBooking($id: ID!) {
    cancelBooking(id: $id) {
      id
      status
      updatedAt
    }
  }
`;


export const CREATE_BOOKING = gql`
  mutation createBooking($input: CreateBookingInput!) {
    createBooking(input: $input) {
      checkoutUrl
      booking {
        id
        eventId
        customerName
        customerEmail
        customerPhone
        horseIds
        startTime
        endTime
        status
        notes
        depositAmount
        depositPaidAt
        createdAt
      }
    }
  }
`
